import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import App from './App';
import './styles/global.css';

// GitHub Pages ではサーバ側リライトが無く、BrowserRouter だと
// 直リンク／リロードで 404 になる。確実に動かすため HashRouter を採用。
// 独自ドメイン + リライト設定がある場合は BrowserRouter に変更可。
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </React.StrictMode>,
);
